import { Fragment } from 'react';
import { LayoutBuilder } from '~/rage/utils';
import { Layouts } from '~/shared';
import { Background } from './components/Background';
import { Hud } from './views/Hud';

const LayoutComponent = () => (
	<Fragment>
		<Background />
		<Hud />
	</Fragment>
);

const Layout = new LayoutBuilder(LayoutComponent)
	.setDisplayName(Layouts.Hud)
	.setHudVisible(true)
	.setIsHud(true)
	.build();

export default Layout;
